<template>
    <div v-loading="locked">
        <div class="row">
            <div class="col-sm-5">
                <h1 style="margin-bottom: 30px">{{ driver.name }}</h1>
                <p>ID: {{ driver.id }}</p>
                <p>Added: {{ driver.created_at }}</p>
            </div>
            <div class="col-sm-4" v-if="loaded">
                <driver-detail-actions-note :driver_id="driver.id" :note="data.driver_info.note" @updated="refresh"></driver-detail-actions-note>
            </div>
            <div class="col-sm-3" style="display: flex; justify-content: flex-end" v-if="loaded">
                <driver-detail-actions-edit-profile :driver_id="driver.id" :driver_info="data.driver_info" :lists="data.lists" @updated="refresh"></driver-detail-actions-edit-profile>
            </div>
        </div>

        <el-tabs type="card" v-model="card" style="margin: 30px 0" v-if="loaded">
            <el-tab-pane label="Driver Info" name="info">
                <driver-detail-driver-info :driver_info="data.driver_info" :lists="data.lists"></driver-detail-driver-info>
            </el-tab-pane>
            <el-tab-pane label="MC/Job Board Leads" name="applications">
                <driver-detail-applications :applications="data.applications"></driver-detail-applications>
            </el-tab-pane>
            <el-tab-pane label="Calls with Recruiters" name="recruiter-calls">
                <driver-detail-recruiter-calls :recruiter_calls="data.recruiter_calls"></driver-detail-recruiter-calls>
            </el-tab-pane>
            <el-tab-pane label="DEJA" name="deja">
                <driver-detail-deja :deja="data.deja"></driver-detail-deja>
            </el-tab-pane>
            <el-tab-pane label="Sends to ATS" name="sends-to-ats">
                <driver-detail-sends-to-ats :sends_to_ats="data.sends_to_ats"></driver-detail-sends-to-ats>
            </el-tab-pane>
            <el-tab-pane label="History" name="driver-history">
                <driver-detail-history :driver_history="data.driver_history"></driver-detail-history>
            </el-tab-pane>
        </el-tabs>
    </div>
</template>

<script>
import DriverDetailDriverInfo from './driver-detail/driver-detail-driver-info.vue';
import DriverDetailApplications from './driver-detail/driver-detail-applications.vue';
import DriverDetailRecruiterCalls from '../../../calls/DirectCall/vue/driver-detail-recruiter-calls.vue';
import DriverDetailDeja from './driver-detail/driver-detail-deja.vue';
import DriverDetailSendsToAts from './driver-detail/driver-detail-sends-to-ats.vue';
import DriverDetailHistory from './../../DriverHistory/vue/driver-detail-history';
import DriverDetailActionsNote from './driver-detail-actions/driver-detail-actions-note.vue';
import DriverDetailActionsEditProfile from './driver-detail-actions/driver-detail-actions-edit-profile.vue';

export default {
    components: {
        DriverDetailDriverInfo,
        DriverDetailApplications,
        DriverDetailRecruiterCalls,
        DriverDetailDeja,
        DriverDetailSendsToAts,
        DriverDetailHistory,
        DriverDetailActionsNote,
        DriverDetailActionsEditProfile,
    },
    props: [
        "driver"
    ],
    data() {
        return {
            locked: false,
            card: null,

            data: {},
        };
    },
    computed: {
        loaded() {
            if(this.data.driver_info) {
                return true;
            }

            return false;
        },
    },
    methods: {
        refresh() {
            this.locked = true;

            return axios.get(url(`admin/driver/${this.driver.id}/data`))
                .then((response) => {
                    this.data = response.data;

                    this.locked = false;
                });
        },
    },
    mounted() {
        this.refresh();

        this.card = "info";
    },
};
</script>
